import { UserAccount } from "@/components/Portal/UserAccount/UserAccount";

export const UserAccountView = () => <UserAccount />;
